// import Button from "../../elements/CustomButton/CustomButton";
// import Card from "../Card/Card";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import React from "react";

import { FormattedMessage } from "react-intl";
import NotificationProvider from "../../elements/NotificationContent/Notifications";

export default class S3Uploader extends React.Component {
  handleFinishedUpload = info => {

    console.log("9 - info=", info);
    console.log("File uploaded with filename", info.filename, info.file.name);
    console.log("Access it on s3 at", info.fileUrl);
    this.props.onFinish(info);
  };

  handleError = info => {
    // console.log("17 - info=", info);
    let notif = NotificationProvider.getFailureNotification();
    notif.message = <FormattedMessage id="ids_errorInUpload_notification" />;
    this.props.sendNotification(notif);
  };

  randomString = () => {
    const arrayChars = new Array(
      "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
      "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z",
      "0", "1", "2", "3", "4", "5", "6", "7", "8", "9");
    const nbChar = 16;
    let strTmp = '';
    for (let i = 0; i < nbChar; i++) {
      strTmp = strTmp + arrayChars[Math.floor(Math.random() * arrayChars.length)];
    }
    return strTmp;
  }

  scrubFilename = (filename) => {
    // console.log("28 - filename=", filename);   
    if (
      this.props.forceFileName !== undefined &&
      this.props.forceFileName !== null &&
      this.props.forceFileName !== ""
    ) {
      let ext = filename.split('.').pop();
      if (ext === null || ext === undefined)
        ext = "";
      else
        ext = "." + ext;

      return this.props.forceFileName + ext;
    }

    const regExpTxt = '#';
    const regExp = new RegExp(regExpTxt, "g");
    // const ret = filename.replace(regExp, '%23') + "_" + new Date().toJSON();

    const ret = "(" + new Date().toJSON() + ")_" + filename.replace(/[^\w\d_\-\.]+/ig, '');
    // const ret = this.randomString() + "_" + new Date().toJSON();

    // console.log("17 - scrubFilename=", ret);
    return ret;
  }

  render = () => {
    // console.log("14 - S3Uploader render", this.props);
    const uploadOptions = {
      server: process.env.REACT_APP_GRAPHQL_ENDPOINT,
      signingUrlQueryParams: { uploadType: "avatar" },
      s3path: this.props.s3path || "tmp/",
      // s3path: "tmp/"
      contentDisposition: "inline",
      scrubFilename: this.scrubFilename
    };

    const s3Url = "https://s3-eu-west-1.amazonaws.com/netwips/";
    const id = this.props.id;

    const src = s3Url + this.props.filename;
    console.log("80 - S3Uploader render", this.props, src, uploadOptions);

    const display = !id ? (
      <this.props.EmptyComponent />
    ) : (
      <this.props.ContentComponent src={src} />
    );
    // return <div></div>;
    return (
      <DropzoneS3Uploader
        style={
          this.props.disabled ?
            { pointerEvents: "none", opacity: "0.4", width: "100%" } :
            { width: "100%" }
        }
        // style={{ width: "100%" }}
        onFinish={values => this.handleFinishedUpload({ ...values, id })}
        onDropRejected={values => this.handleError({ ...values, id })}
        // onDrop={(files, rejectedFiles) => {
        //   console.log("100 - onDrop files=", files);
        //   console.log("100 - onDrop rejectedFiles=", rejectedFiles);
        // }}

        // filename={this.props.filename}
        s3Url={s3Url}
        maxSize={1024 * 1024 * 10}

        //"image/jpeg, image/png, application/pdf"
        accept={this.props.accept}
        // maxSize={1024 * 10}
        upload={uploadOptions}>
        {display}
        {/* {!id && <EmptyLogoCard />} */}
        {/* {!!id && <EmptyLogoCard />} */}
        {/* <UploadDisplay /> */}
      </DropzoneS3Uploader>
    );
  };
}
